import { microFrontListener } from '@b2ag/micro-front-tools'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { PAGE_ANALYTICS_INFO } from '../page-types'

/* ------- MICROFRONT - ORDERS ------- */

export const ordersRoutes = [
  {
    path: '/commandes',
    name: 'orders',
    component: () => import('@b2ag/micro-front-orders/app'),
    props: () => ({
      microFrontName: 'orders',
      viewName: 'ordersForTech',
      techId: useStore().getters.user.technical_sale_information.uuid,
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
      })
    },
    meta: {
      private: true,
      showSelectedCustomer: false,
      changeSelectedCustomer: false,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ORDERS,
    },
  },
  {
    path: '/adherents/:membershipNumber/commandes/:orderId',
    name: 'order-detail-tech',
    component: () => import('@b2ag/micro-front-orders/app'),
    props: (route) => ({
      microFrontName: 'orders',
      viewName: 'orderForTech',
      orderId: route.params.orderId,
      techId: useStore().getters.user.technical_sale_information.uuid,
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
      })
    },
    meta: {
      private: true,
      showSelectedCustomer: false,
      changeSelectedCustomer: false,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.ORDER_DETAILS,
    },
  },
]
